import { StatisticsByCustomerThreeYearsStatisticsDetailsQuery } from "@/gql/graphql";
import { Card, CardBody, CardHeader } from "@stenajs-webui/elements";
import { StandardTable } from "@stenajs-webui/grid";
import * as React from "react";
import { threeYearsVolumeExpectedTableConfig } from "../config/ThreeYearsVolumeExpectedTableConfig";
import { transformThreeYearsVolumeExpectedToTableRows } from "../lib/transformers/customer-table.transformer";

interface Props {
  year: number;
  threeYearsVolumeExpected: StatisticsByCustomerThreeYearsStatisticsDetailsQuery["statistics"]["customerDetails"]["threeYearsVolumeAndExpectedByCustNoAndYear"];
  loading: boolean;
}

export const ThreeYearsVolumeExpectedTable: React.FC<Props> = ({
  year,
  threeYearsVolumeExpected,
  loading,
}) => {
  return (
    <>
      <Card width={"100%"}>
        <CardHeader text={"Expected volume/Volume"} />
        <CardBody>
          <StandardTable
            items={transformThreeYearsVolumeExpectedToTableRows(
              threeYearsVolumeExpected,
              year
            ).sort((a, b) => a.routePairCode.localeCompare(b.routePairCode))}
            loading={loading}
            config={threeYearsVolumeExpectedTableConfig(year)}
          />
        </CardBody>
      </Card>
    </>
  );
};
